import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Constants } from '../common/constant';
import { JWTTokenValidation } from '../common/enum';
import { Mapper } from '../data/mapper';
import { DecodedJWT } from '../data/model';
import { AuthUser } from '../data/model/auth-user-model';

@Injectable({
  providedIn: 'root',
})
export class JwtDecoderService {
  constructor(private jwtHelperService: JwtHelperService, private mapper: Mapper) {}

  // publics
  getUserToken(): string | null {
    const token: string | null = localStorage.getItem(Constants.AUTH_TOKEN);
    return token;
  }
  getCurrentUserFromJWT(): AuthUser | null {
    const jwtPayload: DecodedJWT | null = this.getDecodedUserToken();
    const currentUser: AuthUser | null = new AuthUser();
    if (jwtPayload) {
      currentUser.id = jwtPayload.sub;
      currentUser.email = jwtPayload.email;
      currentUser.fullName = jwtPayload.name;
      currentUser.username = jwtPayload.name;
      currentUser.permissions = jwtPayload.permission;
      currentUser.gender = jwtPayload.gender;
      currentUser.hasCategories = jwtPayload.hasCategories;
      currentUser.whiteLabelDashboardLogoURL = jwtPayload.whiteLabelDashboardLogoURL;
      currentUser.appName = jwtPayload.appName;
      /** @todo added an array to fix wa3i login */
      currentUser.appsType = jwtPayload.appsType || [];
    }
    return currentUser;
  }
  removeCurrentToken(): void {
    localStorage.removeItem(Constants.AUTH_TOKEN);
  }
  isThereValidToken(): JWTTokenValidation {
    const token = this.getUserToken();
    if (token) {
      if (this.isTokenExpired(token)) {
        return JWTTokenValidation.EXPIRED;
      } else {
        return JWTTokenValidation.VALID;
      }
    }
    return JWTTokenValidation.NOT_FOUND;
  }
  saveToken(authToken: string): void {
    if (authToken) {
      localStorage.setItem(Constants.AUTH_TOKEN, authToken);
    }
  }

  // privates
  private getDecodedUserToken(): DecodedJWT | null {
    if (this.getUserToken()) {
      return this.mapper.fromJson(DecodedJWT, this.jwtHelperService.decodeToken(this.getUserToken()));
    } else {
      return null;
    }
  }

  private isTokenExpired(authToken: string | null): boolean {
    return authToken == null || this.jwtHelperService.isTokenExpired(authToken);
  }
}
